import React from "react";
import PropTypes from "prop-types";
import { Badge, Card, CardHeader, Table } from "@opendate-app/setlist";
import { segmentColumns } from "./SegmentRow";
import EmptyFamily from "./EmptyFamily";
import CountBadge from "../../shared/components/CountBadge";

const iconTileStyle = { width: "40px", height: "40px", padding: 0, justifyContent: "center" };
const groupStyle = (index) => ({ padding: "4px 8px", borderTop: index > 0 ? "1px solid var(--sl-border-secondary)" : "none" });

const FamilyIcon = ({ family }) => {
  const Icon = family.icon;
  return (
    <Badge type="badge-color" size="lg" color={family.badge} style={iconTileStyle}>
      <Icon width={20} height={20} aria-hidden="true" style={{ display: "block" }} />
    </Badge>
  );
};

FamilyIcon.propTypes = {
  family: PropTypes.shape({ icon: PropTypes.elementType.isRequired, badge: PropTypes.string }).isRequired,
};

const SegmentFamily = ({ family, segments, teamId, showEmptyState }) => {
  const mine = segments.filter((s) => s.family_key === family.key);
  if (mine.length === 0 && !showEmptyState) return null;

  const groups = family.subcategories.length === 0
    ? [{ key: "all", header: "Segment", items: mine }]
    : family.subcategories
      .map((sub) => ({ key: sub.key, header: sub.label, items: mine.filter((s) => s.subcategory === sub.key) }))
      .filter(({ items }) => items.length > 0);

  return (
    <Card
      padding="none"
      role="region"
      aria-label={family.label}
      header={(
        <CardHeader
          leading={<FamilyIcon family={family} />}
          title={family.label}
          badge={<CountBadge count={mine.length} color="gray" />}
          supportingText={family.blurb}
        />
      )}
    >
      {mine.length === 0 ? (
        <div style={{ padding: "24px" }}>
          <EmptyFamily family={family} />
        </div>
      ) : groups.map(({ key, header, items }, index) => (
        <div key={key} style={groupStyle(index)}>
          <Table columns={segmentColumns(teamId, header)} data={items} getRowKey={(segment) => segment.id} stackBelow={640} />
        </div>
      ))}
    </Card>
  );
};

SegmentFamily.propTypes = {
  family: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string,
    icon: PropTypes.elementType,
    badge: PropTypes.string,
    blurb: PropTypes.string,
    subcategories: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, label: PropTypes.string })),
  }).isRequired,
  segments: PropTypes.arrayOf(PropTypes.object).isRequired,
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  showEmptyState: PropTypes.bool,
};

export default SegmentFamily;
